import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  options: [],
  values: {
    oggetto: "",
    tipo: "",
    categoria: "",
    stato: "",
    priorita: "",
  },
};

const issueFiltersSlice = createSlice({
  name: "issueFilters",
  initialState,
  reducers: {
    setIssueFilterOptions: (state, action) => {
      state.options = action.payload;
    },
    setIssueFilterValues: (state, action) => {
      state.values = action.payload;
    },
    clearIssueFilterValues: (state) => {
      state.values = initialState.values;
    },
    // Keep this as an alias for the Navbar API call to prevent breaking it
    setIssueFilters: (state, action) => {
      state.options = action.payload;
    },
  },
});

export const {
  setIssueFilterOptions,
  setIssueFilterValues,
  clearIssueFilterValues,
  setIssueFilters,
} = issueFiltersSlice.actions;
export default issueFiltersSlice.reducer;
